module.exports = __webpack_public_path__ + "img/8.0b414927.png";